import { errorAction, successfulAction } from '@shared/actions';
import { isNotFoundError } from '@utils/error';
import { STATUS_CODE } from '@shared/constants';
import { FETCH_SHOP } from '../actionTypes';

const fetchShop = ({ run }) => async (dispatch, _, axios) => {
  try {
    dispatch({ type: FETCH_SHOP });
    const { success, error, data } = await run(axios);
    if (!success) {
      dispatch(
        errorAction({
          type: FETCH_SHOP,
          error,
          errorCode: isNotFoundError(error)
            ? STATUS_CODE.NOT_FOUND
            : STATUS_CODE.INTERNAL_ERROR,
        }),
      );

      return null;
    }

    dispatch(successfulAction({ type: FETCH_SHOP, payload: data }));

    return data.shop;
  } catch (error) {
    dispatch(
      errorAction({
        type: FETCH_SHOP,
        error,
        errorCode: STATUS_CODE.INTERNAL_ERROR,
      }),
    );

    return null;
  }
};

export default fetchShop;
